import { AccountMessage, AccountTitle } from "../../../../../../Constants/Constants";
import { useAppSelector } from "../../../../../../ReduxToolkit/Hooks";
import CommonMediaHeading from "../Common/CommonMediaHeading";
import ChangeNumber from "./ChangeNumber";
import DeleteAccount from "./DeleteAccount";
import Privacy from "./Privacy";
import RequestAccountInfo from "./RequestAccountInfo";
import Security from "./Security";
import TwoStepVerification from "./TwoStepVerification";

const Account = () => {
  const { settingsActiveTab } = useAppSelector((state) => state.mainSidebar);
  return (
    <div className="setting-block border-0">
      <div className={`block ${settingsActiveTab === "account" ? "open" : ""}`}>
        <CommonMediaHeading title={AccountTitle} />
        <div className="template-according" id="accordion">
          <Security />
          <Privacy />
          <TwoStepVerification />
          <ChangeNumber />
          <RequestAccountInfo />
          <DeleteAccount />
        </div>
      </div>
      <CommonMediaHeading title={AccountTitle} text={AccountMessage} type="account" />
    </div>
  );
};

export default Account;
